import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import ConfirmModal from "../../../components/modal/confirmModal";
import FailModal from "../../../components/modal/failModal";
import { PREFIX, SUCCESS_CODE } from "../../../lib/const";
import { splitFullName } from "../../../lib/utils/helper";
import { createStaff, updateStaff } from "../../../services/userManagement";
const { Title } = Typography;

const Option = Select.Option;

const ActionModal = (props) => {
  const {
    open,
    setOpen,
    actionTypeModal,
    setActionTypeModal,
    position,
    editData,
    setEditData,
    setFetchData,
  } = props;

  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const [submittable, setSubmittable] = useState(true);
  const [confirmModal, setConfirmModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [data, setData] = useState({});

  const onEditData = useCallback(
    (data) => {
      const fullName = splitFullName(data?.fullName);
      setData(data);

      form.setFieldsValue({
        prefix: data.prefix ? data.prefix : "",
        fullName: data.fullName ? data.fullName : "",
        firstName: data.staffName ? data.staffName : fullName[0],
        lastName: data.staffLastname ? data.staffLastname : fullName[1],
        positionUniqueId: data.positionUniqueId ? data.positionUniqueId : "",
      });
    },
    [form]
  );

  useEffect(() => {
    if (Object.keys(editData).length > 0 && actionTypeModal !== "add") {
      onEditData(editData);
    }

    if (actionTypeModal === "add") {
      form.resetFields();
    }
  }, [onEditData, form, actionTypeModal, editData]);

  const onFinish = async () => {
    setConfirmModal(false);

    const request = {
      prefix: form.getFieldsValue().prefix,
      staffName: form.getFieldsValue().firstName,
      staffLastname: form.getFieldsValue().lastName,
      positionUniqueId: form.getFieldsValue().positionUniqueId,
    };

    if (actionTypeModal === "add") {
      const res = await createStaff(request);
      if (res.data.code === SUCCESS_CODE) {
        form.resetFields();
        setFetchData(true);
        setOpen(false);
      } else {
        setFailModal(true);
        if (res?.data?.code === "ERR-9999") {
          setErrMsg("เกิดข้อผิดพลาดภายในเซิร์ฟเวอร์");
        } else {
          setErrMsg("ขออภัย, มีเกิดข้อผิดพลาดบางอย่าง");
        }
      }
    } else {
      const res = await updateStaff(data.staffUniqueId, request);
      if (res.data.code === SUCCESS_CODE) {
        setFetchData(true);
        setOpen(false);
      } else {
        setFailModal(true);
        if (res?.data?.code === "ERR-9999") {
          setErrMsg("เกิดข้อผิดพลาดภายในเซิร์ฟเวอร์");
        } else {
          setErrMsg("ขออภัย, มีเกิดข้อผิดพลาดบางอย่าง");
        }
      }
    }

    setActionTypeModal("");
  };

  const onCancel = () => {
    setOpen(false);
    setActionTypeModal("");
    setEditData({});
    setData({});
  };

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(
        () => {
          setSubmittable(true);
        },
        () => {
          setSubmittable(false);
        }
      );
  }, [values, form]);

  return (
    <>
      <Modal open={open} onCancel={onCancel} footer={false} width={700}>
        <Row justify="center">
          <Col span={24} align="center">
            <Title level={5}>
              {actionTypeModal === "add"
                ? "เพิ่มเจ้าหน้าที่"
                : "แก้ไขข้อมูลเจ้าหน้าที่"}
            </Title>
          </Col>
        </Row>

        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
          name="validateOnly"
        >
          <Row gutter={[24, 12]}>
            <Col span={12}>
              <Form.Item
                label="คำนำหน้าชื่อ"
                name={"prefix"}
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <Select
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  placeholder="กรุณาเลือก"
                >
                  {PREFIX.map((item) => (
                    <Option value={item.value} key={item.value}>
                      {item.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}></Col>
            <Col span={12}>
              <Form.Item
                label="ชื่อจริง"
                name="firstName"
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <Input placeholder="" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="นามสกุล"
                name="lastName"
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <Input placeholder="" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="ตำแหน่ง"
                name="positionUniqueId"
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <Select
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  placeholder="กรุณาเลือก"
                >
                  {position &&
                    position.map((item) => (
                      <Option
                        value={item.positionUniqueId}
                        key={item.positionUniqueId}
                      >
                        {item.positionNameTh}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Space
            direction="horizontal"
            style={{
              width: "100%",
              justifyContent: "center",
              marginTop: 40,
              marginBottom: 20,
            }}
          >
            <Button key="back_modal" onClick={onCancel}>
              ยกเลิก
            </Button>
            <Button
              type="primary"
              onClick={() => {
                setConfirmModal(true);
              }}
              disabled={
                !submittable ||
                _.isEmpty(form.getFieldsValue().prefix) ||
                _.isEmpty(form.getFieldsValue().lastName) ||
                _.isEmpty(form.getFieldsValue().firstName) ||
                _.isEmpty(form.getFieldsValue().positionUniqueId)
              }
            >
              ยืนยัน
            </Button>
          </Space>

          <ConfirmModal
            actionType={"save"}
            title={"ยืนยันการบันทึกข้อมูล"}
            open={confirmModal}
            modalText={"คุณต้องการบันทึกข้อมูล ?"}
            onOk={onFinish}
            onCancel={() => {
              setConfirmModal(false);
            }}
          />

          <FailModal
            open={failModal}
            setOpen={setFailModal}
            subTitle={errMsg}
            setErrMsg={setErrMsg}
          />
        </Form>
      </Modal>
    </>
  );
};

export default ActionModal;
